import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Clock, ChatTeardropDots } from "@phosphor-icons/react";

const JOTFORM_ID = "261530549104047";

export default function Intake() {
  return (
    <main data-testid="intake-page" className="bg-[#0A0A0A] text-white font-body min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 lg:py-20">
        <Link
          to="/"
          data-testid="intake-back-home"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white/60 hover:text-[#FF1B91] transition-colors mb-10"
        >
          <ArrowLeft size={14} weight="bold" /> Back to Sweat With Slay
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#FF1B91]" />
          <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold">Coaching Intake</p>
        </div>
        <h1 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter mb-6">
          Let&apos;s build{" "}
          <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">your plan.</span>
        </h1>
        <p className="text-white/75 leading-relaxed max-w-2xl mb-10 text-lg">
          Five minutes. Real answers. I read every single one personally and reply within 48 hours.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-10">
          <div className="border border-white/10 bg-[#0F0F0F] p-5 flex items-start gap-3">
            <Clock size={20} weight="bold" className="text-[#FF1B91] mt-0.5 shrink-0" />
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/45 font-bold">Takes</div>
              <div className="font-semibold mt-0.5">~15 minutes</div>
            </div>
          </div>
          <div className="border border-white/10 bg-[#0F0F0F] p-5 flex items-start gap-3">
            <ChatTeardropDots size={20} weight="bold" className="text-[#FF1B91] mt-0.5 shrink-0" />
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/45 font-bold">Reply</div>
              <div className="font-semibold mt-0.5">Within 48 hrs</div>
            </div>
          </div>
          <div className="border border-white/10 bg-[#0F0F0F] p-5 flex items-start gap-3">
            <ShieldCheck size={20} weight="bold" className="text-[#FF1B91] mt-0.5 shrink-0" />
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/45 font-bold">Private</div>
              <div className="font-semibold mt-0.5">Only I see this</div>
            </div>
          </div>
        </div>

        <div className="border border-white/10 bg-[#0F0F0F] p-2 sm:p-4">
          <iframe
            data-testid="intake-iframe"
            title="Sweat With Slay Coaching Intake"
            src={`https://form.jotform.com/${JOTFORM_ID}?embed=1`}
            className="w-full border-0 bg-white"
            style={{ minHeight: "1400px" }}
            scrolling="auto"
            allow="geolocation; microphone; camera; fullscreen"
          />
        </div>

        <p className="mt-6 text-[11px] uppercase tracking-[0.3em] text-white/40 text-center">
          By submitting, you agree to our <Link to="/privacy" className="hover:text-[#FF1B91]">privacy policy</Link> &amp; <Link to="/terms" className="hover:text-[#FF1B91]">terms</Link>.
        </p>
      </div>
    </main>
  );
}
